<template>
  <div class="pageContent">
    <el-tabs v-model="activeName">
      <el-tab-pane label="提成记录" name="first">
        <div class="options">
          <el-form :inline="true" class="demo-form-inline">
            <el-form-item label="门店">
              <el-select
                size="small"
                clearable
                v-model="room_id"
                placeholder="选择门店"
                @clear="clear(2)"
                @change="selects($event, 1)"
              >
                <el-option
                  v-for="e in room_list"
                  :key="e.id"
                  :label="e.name"
                  :value="e.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="员工">
              <el-select
                size="small"
                clearable
                v-model="emp_id"
                placeholder="选择员工"
                @clear="clear(1)"
                @change="selects"
              >
                <el-option
                  v-for="item in empList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开始时间">
              <el-date-picker
                size="small"
                v-model="start_date"
                type="datetime"
                placeholder="选择开始时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time="00:00:00"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                size="small"
                v-model="end_date"
                type="datetime"
                placeholder="选择结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                default-time="23:59:59"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button size="small" type="primary" @click="getListData()"
                >搜索</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="table_box">
          <el-card style="width: 67%;margin-bottom: 10px" shadow="never">
            <div style=" display: flex;justify-content: space-around">
              <div>
                <div class="title">充值金额</div>
                <div class="money">
                  ¥{{ count.total_recharge_amount }}
                </div>
              </div>
              <div>
                <div class="title">充值提成</div>
                <div class="money">
                  ¥{{ count.total_recharge_commission }}
                </div>
              </div>
              <div>
                <div class="title">加油金额</div>
                <div class="money">
                  ¥{{ count.total_consume_amount }}
                </div>
              </div>
              <div>
                <div class="title">加油升数</div>
                <div class="money">
                  {{ count.total_consume_num
                  }}<span style="font-size: 14px">(升)</span>
                </div>
              </div>
              <div>
                <div class="title">加油提成</div>
                <div class="money">
                  ¥{{ count.total_consume_commission }}
                </div>
              </div>
            </div>
          </el-card>
          <el-table :data="listData" border>
            <el-table-column label="员工id" prop="id"></el-table-column>
            <el-table-column label="门店" prop="show_room"></el-table-column>
            <el-table-column label="员工姓名" prop="name"></el-table-column>
            <el-table-column label="手机号" prop="mobile"></el-table-column>
            <el-table-column
              label="充值金额"
              prop="recharge_amount"
            ></el-table-column>
            <el-table-column
              label="充值提成"
              prop="recharge_commission"
            ></el-table-column>
            <el-table-column
              label="加油金额"
              prop="consume_amount"
            ></el-table-column>
            <el-table-column
              label="加油升数"
              prop="consume_num"
            ></el-table-column>
            <el-table-column
              label="加油提成"
              prop="consume_commission"
            ></el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="提成规则" name="second">
        <div class="options">
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="gotoAdd()"
            >添加规则</el-button
          >
        </div>
        <div class="table_box">
          <el-table :data="tableData" border>
            <el-table-column label="规则名称" prop="name"></el-table-column>
            <el-table-column
              label="适用门店"
              prop="room.name"
            ></el-table-column>
            <el-table-column
              label="规则类型"
              prop="show_type"
            ></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="editItem(scope.row.id)"
                  >修改</el-button
                >
                <el-button type="text" @click="detailItem(scope.row.id)"
                  >详情</el-button
                >
                <el-button type="text" @click="delItem(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog
      :visible.sync="showDetail"
      title="规则详情"
      @close="closeDetail()"
      width="800px"
    >
      <div class="type_title" v-if="info.type == 1">充值规则</div>
      <div class="type_title" v-else>加油规则</div>
      <el-form class="form_item" size="small" label-width="auto">
        <el-form-item label="规则名称 : ">
          <div>{{ info.name }}</div>
        </el-form-item>
        <el-form-item label="门店 : ">
          <div>{{ room.name }}</div>
        </el-form-item>
        <el-form-item label="规则类型 : ">
          <div v-if="detailData.rule_type == 1">按照每单提成计算</div>
          <div v-if="detailData.rule_type == 2">按照总金额提成计算</div>
        </el-form-item>
        <el-form-item label="提成计算方式 : " v-if="info.type == 2">
          <div v-if="detailData.rule_unit == 1">按照金额计算提成</div>
          <div v-if="detailData.rule_unit == 2">按照升数计算提成</div>
        </el-form-item>
        <el-form-item label="提成计算金额 : ">
          <div v-if="detailData.rule_rate == 1">按照买单价格计算</div>
          <div v-if="detailData.rule_rate == 2">按照实收款计算</div>
        </el-form-item>
        <el-form-item label="适用员工 : ">
          <div>
            {{ detailData.emp_name }}
          </div>
        </el-form-item>
        <el-form-item label="适用油品 : " v-if="info.type == 2">
          <div>
            {{ detailData.goods_name }}
          </div>
        </el-form-item>
        <el-form-item label="提成细则 : ">
          <div
            class="rule_item"
            v-for="(rule, idx) in detailData.rule"
            :key="idx"
          >
            <span>{{ info.type == 1 ? "充值" : "销售" }}</span>
            <span
              >{{ rule.start
              }}{{ detailData.rule_unit == 2 ? "升" : "元" }}</span
            >
            <span>至</span>
            <span
              >{{ rule.end }}{{ detailData.rule_unit == 2 ? "升" : "元" }}</span
            >
            <span>可提成</span>
            <span
              >{{ rule.rate }}{{ detailData.rule_rate == 2 ? "%" : "元" }}</span
            >
            <span v-if="rule.max != ''">最高提成{{ rule.max }}元</span>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  commissionDel,
  commissionDetail,
  commissionList,
  empCommission,
  employeeList,
  storeSelect
} from "@/api/employee.js";
import { loading_options } from "@/utils/loading";
import { Loading } from "element-ui";
import { goodsOptions } from "@/api/vip.js";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      tableData: [], // 规则数据
      detailData: {}, // 规则详情
      info: {},
      orderList: [], // 订单规则
      voucherList: [], // 充值规则
      showDetail: false, // 详情弹窗
      activeName: "first", // tab页
      listData: [], // 员工提成记录
      emp_id: "",
      room_id: "",
      count: {},
      start_date: "",
      end_date: "",
      room: {},
      room_list: [],
      empList: [],
      page: 1,
      goods: []
    };
  },
  mounted() {
    this.getRoom();
    this.getRuleData();
    this.getListData();
  },
  methods: {
    //清空门店选择
    clear(type) {
      if (type == 1) {
        this.emp_id = "";
      } else {
        this.room_id = "";
      }
      this.getListData();
    },
    //获取门店
    async getRoom() {
      const res = await storeSelect({ app_id: this.app_id });
      if (res.code == 200) {
        this.room_list = res.data;
      }
    },
    //选择门店
    selects(val, key) {
      if (key == 1) {
        this.getemp(val);
      }
      this.getListData();
    },
    //获取员工
    async getemp(id) {
      const res = await employeeList({ app_id: this.app_id, room_id: id });
      this.empList = res.data;
    },
    async getgoods() {
      const res = await goodsOptions({ app_id: this.app_id });
      this.goods = res.data;
      console.log(res);
    },
    getRuleData() {
      var data = {
        token: this.token,
        app_id: this.app_id
      };
      commissionList(data).then(res => {
        if (res.code == 200) {
          this.tableData = res.data;
          this.tableData.forEach((item, i) => {
            item.show_type = item.type == 1 ? "充值" : "加油";
          });
        } else {
          this.$message(res.msg);
        }
      });
      this.getgoods();
      this.getemp();
    },
    delItem(id) {
      console.log(id);
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          var data = {
            token: this.token,
            app_id: this.app_id,
            id: id
          };
          commissionDel(data).then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功"
              });
              this.getRuleData();
            } else {
              this.$message({
                type: "error",
                message: res.msg
              });
            }
          });
        })
        .catch(()=>{
          this.$message.info('已经取消删除')
        });
    },
    editItem(id) {
      this.$router.push({
        path:'/apply/newVip/13/home/royaltiesSet1',
        query:{
          id:id
        }
      })
    },
    gotoAdd(id) {
      if (id) {
        this.$router.push({ path: "royaltiesSet1", query: { eid: id } });
      } else {
        this.$router.push("royaltiesSet1");
      }
    },
    detailItem(id) {
      var data = {
        app_id: this.app_id,
        id: id
      };
      commissionDetail(data).then(res => {
        if (res.code == 200) {
          let emp_name = [];
          let goods_name = [];
          this.info = res.data;
          this.detailData = res.data.item;
          if (this.detailData.employee_list.length > 0) {
            this.detailData.employee_list.forEach((item, i) => {
              emp_name.push(item.name);
            });
            this.detailData.emp_name = emp_name.join(" ，");
          }
          if (this.detailData.goods_id&&this.detailData.goods_id!=0) {
            this.detailData.goods_id.split(",").forEach(item => {
              goods_name.push(this.goods.find(x => x.id == item).name);
            });
            this.detailData.goods_name = goods_name.join(" ，");
          }
          this.room = res.data.room;
          this.showDetail = true;
        }
      });
    },
    closeDetail() {
      this.showDetail = false;
      this.detailData = {};
      this.orderList = [];
      this.voucherList = [];
    },
    // 员工提成记录
    getListData() {
      // showLoading();
      const loading = Loading.service(loading_options)
      var data = {
        app_id: this.app_id
      };
      if (this.emp_id != "") {
        data.emp_id = this.emp_id;
      }
      if (this.room_id != "") {
        data.room_id = this.room_id;
      }
      if (this.start_date && this.end_date) {
        data.start_time = this.start_date;
        data.end_time = this.end_date;
      }
      empCommission(data).then(res => {
        if (res.code == 200) {
          this.listData = res.data.list;
          this.listData.forEach((item, i) => {
            if (this.room_list.find(x => x.id == item.room_id)) {
              item.show_room = this.room_list.find(
                x => x.id == item.room_id
              ).name;
            }
          });
          this.count = res.data.count;
          // hideLoading();
          this.$nextTick((_)=>{
            loading.close()
          })
        }else {
          this.$nextTick((_)=>{
            loading.close()
          })
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.pageContent {
  border: 20px solid #f1f2f6;
  padding: 0 20px 10px 20px;
  height: 100%;
  overflow: auto;
  .options {
    margin-bottom: 10px;
    line-height: 40px;
    display: flex;
    padding: 6px 0;
    flex-wrap: wrap;
  }
  .table_box {
    margin-bottom: 20px;
  }
  .form_input {
    width: 220px;
    display: inline-block;
    margin-right: 10px;
  }
  .type_title {
    font-size: 15px;
    font-weight: bold;
    margin-top: -20px;
    margin-bottom: 20px;
  }
  .half_width {
    display: inline-block;
    width: 33%;
  }
  .rule_item {
    line-height: 30px;
    span {
      margin-right: 10px;
    }
  }
  .form_item {
    // border-bottom: 1px dashed #aaa;
    margin-bottom: 10px;
  }
  .box {
    width: 360px;
    line-height: 40px;
    .title {
      display: inline-block;
      padding-right: 15px;
      font-size: 14px;
    }
    .input_box {
      display: inline-block;
      width: 240px;
    }
  }
}
.title{
  text-align: center;font-size: 13px;margin-bottom: 10px
}
.money{
  text-align: center;font-size: 20px;font-weight: 500
}
</style>
